import localeEn from './localeEn';
import localeEs from './localeEs';
import localePt from './localePt';

export default { es: localeEs.es, pt: localePt.pt, en: localeEn.en };
